import { memo, type SVGAttributes } from "react";

import { default as ApolloSm } from "./apolloSm.svg?react";
import { default as AresSm } from "./aresSm.svg?react";
import { default as VegaSm } from "./vegaSm.svg?react";

type Company = "APOLLO" | "ARES";

const getLogo = (company?: Company) => {
  switch (company) {
    case "APOLLO":
      return ApolloSm;
    case "ARES":
      return AresSm;
    default:
      return VegaSm;
  }
};

export const CompanyLogos = memo(
  ({
    company,
    ...props
  }: SVGAttributes<SVGSVGElement> & {
    company?: Company;
  }) => {
    const Logo = getLogo(company);

    return <Logo {...props} />;
  },
);
